var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCuet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1236_2452)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 1,
    width: 56,
    height: 56,
    rx: 12,
    fill: "url(#paint0_linear_1236_2452)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9997 18.5C32.6201 18.5 32.2451 18.5656 31.8888 18.6922L18.7404 23.4406C18.2951 23.6047 17.9997 24.0266 17.9997 24.5C17.9997 24.9734 18.2951 25.3953 18.7404 25.5594L21.4544 26.5391C20.6857 27.7484 20.2497 29.1781 20.2497 30.6828V32C20.2497 33.3313 19.7435 34.7047 19.2044 35.7875C18.8997 36.3969 18.5529 36.9969 18.1497 37.55C17.9997 37.7516 17.9576 38.0141 18.0419 38.2531C18.1263 38.4922 18.3232 38.6703 18.5669 38.7313L21.5669 39.4813C21.7638 39.5328 21.9747 39.4953 22.1482 39.3875C22.3216 39.2797 22.4435 39.1016 22.481 38.9C22.8841 36.8937 22.6826 35.0938 22.3826 33.8047C22.2326 33.1391 22.031 32.4594 21.7497 31.8359V30.6828C21.7497 29.2672 22.2279 27.9313 23.0576 26.8625C23.6622 26.1359 24.4451 25.55 25.3638 25.1891L32.7232 22.2969C33.1076 22.1469 33.5435 22.3344 33.6935 22.7188C33.8435 23.1031 33.656 23.5391 33.2716 23.6891L25.9122 26.5813C25.331 26.8109 24.8201 27.1625 24.4029 27.5938L31.8841 30.2937C32.2404 30.4203 32.6154 30.4859 32.9951 30.4859C33.3747 30.4859 33.7497 30.4203 34.106 30.2937L47.2591 25.5594C47.7044 25.4 47.9997 24.9734 47.9997 24.5C47.9997 24.0266 47.7044 23.6047 47.2591 23.4406L34.1107 18.6922C33.7544 18.5656 33.3794 18.5 32.9997 18.5ZM23.9997 36.125C23.9997 37.7797 28.031 39.5 32.9997 39.5Cnan nan 41.9997 37.7797 41.9997 36.125L41.2826 29.3094L34.6169 31.7188C34.0966 31.9062 33.5482 32 32.9997 32Cnan nan 31.8982 31.9062 31.3826 31.7188L24.7169 29.3094L23.9997 36.125Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1236_2452",
    x: 0,
    y: 0,
    width: 66,
    height: 66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1236_2452"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1236_2452"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_dropShadow_1236_2452"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1236_2452",
    result: "effect2_dropShadow_1236_2452"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1236_2452",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1236_2452",
    x1: 5,
    y1: 1,
    x2: 61,
    y2: 57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC4899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DB2777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCuet);
export default __webpack_public_path__ + "static/media/ic_cuet.c630d6e108154daf6a95805f6758210f.svg";
export { ForwardRef as ReactComponent };